// client/src/api/chatbotAPI.js
// Matches pattern of cognitiveAPI.js — plain object, axiosInstance, same error handling.

import axiosInstance from '../utilities/axiosInstance';

const chatbotAPI = {

  // ============================================================================
  // SEND MESSAGE
  // POST /api/chatbot/chat
  // ============================================================================

  /**
   * Send a message to Prof-iX and get a response.
   * @param {string} courseId    - Course identifier (e.g. 'IOT101')
   * @param {string} courseName  - Human-readable course name (e.g. 'IoT Systems Development')
   * @param {string} message     - The student's current question
   * @param {Array}  history     - Previous messages [{ role: 'user'|'assistant', content: string }]
   * @returns {Promise<{ success: boolean, answer?: string, sources?: Array, model?: string, error?: string }>}
   */
  sendChatMessage: async (courseId, courseName, category, message, history = []) => {
    try {
      const response = await axiosInstance.post('/api/chatbot/chat', {
        courseId,
        courseName,
        category,
        message,
        history,
      });
      return response.data; // { success, answer, sources, model }
    } catch (error) {
      return error?.response?.data || {
        success: false,
        error: `Failed to get response from Prof-iX: ${error.message}`,
      };
    }
  },

  sendGatewayMessage: async (message, history = []) => {
    try {
      const response = await axiosInstance.post('/api/chatbot/gateway', {
        message,
        history,
      });
      return response.data;
    } catch (error) {
      return error?.response?.data || {
        success: false,
        error: `Failed to get response from Prof. iX: ${error.message}`,
      };
    }
  },

};

export default chatbotAPI;